import { EventEntity } from 'stores/common/PubSub';
import { TableCellController } from 'stores/common/TableController';

export enum TableFactoryStoreEventKind {
  COMMENT_SELECT = 'TABLE_FACTORY/COMMENT_SELECT',
  COMMENT_UNSELECT = 'TABLE_FACTORY/COMMENT_UNSELECT',
}

export type TableFactoryStoreCommentSelectEvent = EventEntity<
  TableFactoryStoreEventKind.COMMENT_SELECT,
  { payload: TableCellController }
>;

export type TableFactoryStoreCommentUnselectEvent =
  EventEntity<TableFactoryStoreEventKind.COMMENT_UNSELECT>;

export const isTableFactoryStoreCommentSelectEvent = (
  event: EventEntity
): event is TableFactoryStoreCommentSelectEvent => {
  return event.kind === TableFactoryStoreEventKind.COMMENT_SELECT;
};

export const isTableFactoryStoreCommentUnselectEvent = (
  event: EventEntity
): event is TableFactoryStoreCommentUnselectEvent => {
  return event.kind === TableFactoryStoreEventKind.COMMENT_UNSELECT;
};

export type TableFactoryStoreEvents =
  | TableFactoryStoreCommentSelectEvent
  | TableFactoryStoreCommentUnselectEvent;
